import { Component, OnDestroy } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {OrdersPage} from "../orders/orders";
import {PvPage} from "../pv/pv";
import {BarcodeScanner} from "@ionic-native/barcode-scanner";
import {ReklamationPage} from "../reklamation/reklamation";

/**
 * Generated class for the WareneingangPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-wareneingang',
  templateUrl: 'wareneingang.html',
})
export class WareneingangPage implements OnDestroy {

  sub;
  nummer;

  constructor(public navCtrl: NavController, public navParams: NavParams, public data: DataProvider, private barcodeScanner: BarcodeScanner) {
    this.sub = this.data.roleChange.subscribe(daten => {
      if (daten !== 'Wareneingang') {
        this.navCtrl.setRoot(OrdersPage);
      }
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WareneingangPage');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  scan() {
    this.barcodeScanner.scan({torchOn: true}).then((barcodeData) => {
      let scanned_pv = '0';
      if (barcodeData.format === 'QR_CODE') {
        const bstring = barcodeData.text.split('#');
        if (bstring[1] !== undefined) {
          scanned_pv = bstring[1];
        }
      }
      if (barcodeData.format === 'CODE_39') {
        scanned_pv = barcodeData.text;
      }
      this.openPv(scanned_pv);
    }, (err) => {

    });
  }

  openPv(number) {
    this.navCtrl.push(PvPage, {
      item: number
    });
  }

  reklamation() {
    this.navCtrl.push(ReklamationPage, {pv: {nummer: ''}});
  }

}



// WEBPACK FOOTER //
// ./src/pages/wareneingang/wareneingang.ts